import { rest } from 'msw';
import {
  mockAccountantAuthentication,
  mockAggreg8AccountsResponse,
  mockAggreg8Response,
  mockBankAccountDisplayNameUpdate,
  mockBooked,
  mockCreateCompany,
  mockCreateAccountant,
  mockCreateIsc,
  mockCreateToken,
  mockDeleteAccountant,
  mockDeleteBankAccount,
  mockDeleteCompanyIsc,
  mockPatchCompanyAggreg8accounts,
  mockDeleteFile,
  mockEntrepreneurAuthentication,
  mockEntrepreneurRead,
  mockEntrepreneurUpdate,
  mockExportTransaction,
  mockGetAggreg8Tokens,
  mockListAccessTokens,
  mockListAccountants,
  mockListBankAccount,
  mockListCompanies,
  mockListIntegrators,
  mockLogin,
  mockReadBankAccount,
  mockReadCompany,
  mockReadFile,
  mockTokenRevoke,
  mockUpdateAccountant,
  mockUploadFile,
  mockAggreg8BanksResponse,
  mockCompanyUpdate,
  mockAggreg8StartPull,
  mockPatchBankConfig,
  mockGetBankConfigs,
  mockAggreg8UserFlowInit,
} from './resolver';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const handlers = [
  /**ENTREPRENEUR */
  rest.post(`${BASE_URL}/entr/auth`, mockEntrepreneurAuthentication),
  rest.get(`${BASE_URL}/entr`, mockEntrepreneurRead),
  rest.put(`${BASE_URL}/entr`, mockEntrepreneurUpdate),

  /**ACCOUNTANT */
  rest.post(`${BASE_URL}/accountant/auth`, mockAccountantAuthentication),
  rest.post(`${BASE_URL}/accountant`, mockCreateAccountant),
  rest.post(`${BASE_URL}/accountant/:id`, mockUpdateAccountant),
  rest.delete(`${BASE_URL}/accountant/:companyId/:accountantId`, mockDeleteAccountant),
  rest.get(`${BASE_URL}/accountants/:id`, mockListAccountants),

  /**COMPANY */
  rest.get(`${BASE_URL}/companies`, mockListCompanies),
  rest.post(`${BASE_URL}/company`, mockCreateCompany),
  rest.get(`${BASE_URL}/company/:id`, mockReadCompany),
  rest.put(`${BASE_URL}/company/:id`, mockCompanyUpdate),
  rest.delete(`${BASE_URL}/company/isc`, mockDeleteCompanyIsc),
  rest.patch(`${BASE_URL}/company/aggreg8accounts/:id`, mockPatchCompanyAggreg8accounts),
  rest.patch(`${BASE_URL}/company/bankConfig/:id`, mockPatchBankConfig),

  /**BANKACCOUNT */
  rest.get(`${BASE_URL}/bankaccounts`, mockListBankAccount),
  rest.patch(`${BASE_URL}/bankaccount/:accountNr/:displayName`, mockBankAccountDisplayNameUpdate),
  //msw bug
  rest.patch(`${BASE_URL}/bankaccount/:accountNr/`, mockBankAccountDisplayNameUpdate),
  rest.delete(`${BASE_URL}/bankaccount/:accountNr/:originate`, mockDeleteBankAccount),

  /**FILE */
  rest.delete(`${BASE_URL}/file/:id`, mockDeleteFile),
  rest.post(`${BASE_URL}/file/:id`, mockUploadFile),
  rest.get(`${BASE_URL}/file/:id`, mockReadFile),

  /**AGGREG8 */
  rest.get(`${BASE_URL}/aggreg8/token`, mockGetAggreg8Tokens),
  rest.delete(`${BASE_URL}/aggreg8/isc`, mockCreateIsc),
  rest.get(`${BASE_URL}/aggreg8/banks`, mockAggreg8BanksResponse),
  rest.get(`${BASE_URL}/aggreg8/accounts`, mockAggreg8AccountsResponse),
  rest.post(`${BASE_URL}/aggreg8/pull`, mockAggreg8StartPull),
  rest.post(`${BASE_URL}/aggreg8/user-flow/init`, mockAggreg8UserFlowInit),
  //This is not part of our API, this is AGGREG8's endpoints
  rest.get('https://api.sandbox2.aggreg8.hu/v4/banks-non-aisp/synctask', mockAggreg8Response),

  /**CLIENT */
  rest.get(`${BASE_URL}/integrator/tokens`, mockListAccessTokens),
  rest.get(`${BASE_URL}/integrators`, mockListIntegrators),
  rest.post(`${BASE_URL}/integrator/token`, mockCreateToken),
  rest.patch(`${BASE_URL}/integrator/token`, mockTokenRevoke),

  /**TRANSACTION */
  rest.post(`${BASE_URL}/bankaccounts-transactions/:page`, mockReadBankAccount),
  rest.post(`${BASE_URL}/bankaccount/export`, mockExportTransaction),

  /**AUTHENTICATION */
  rest.get(`${BASE_URL}/me`, mockLogin),

  /**LOG */
  rest.post(`${BASE_URL}/booked`, mockBooked),

  /**HEALTHCHECK */
  rest.post(`${BASE_URL}/healthcheck`, null),

  /**BANK CONFIGS */
  rest.get(`${BASE_URL}/bankConfigs`, mockGetBankConfigs),
];
